module.exports = __webpack_public_path__ + "static/media/as.e922b2df.svg";